// Project data - separated for maintainability
export const projectsData = [
  {
    id: 'supply-chain',
    title: 'Supply Chain Forecasting & Inventory Optimization',
    description: 'Production-style Python analytics system for demand forecasting, inventory optimization, and risk simulation using the M5 dataset.',
    image: 'https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxzdXBwbHklMjBjaGFpbiUyMGRhc2hib2FyZHxlbnwwfHx8fDE3NzczOTY1Njh8MA&ixlib=rb-4.1.0&q=85',
    tags: ['Forecasting', 'Data Engineering', 'Decision Support'],
    tech: ['Python', 'XGBoost', 'FastAPI', 'Streamlit', 'Docker', 'Evidently', 'Monte Carlo'],
    highlights: [
      'Built ETL-style pipeline for multi-table retail demand data',
      'Engineered lag, rolling, calendar, and price features',
      'Trained XGBoost model with MAE, RMSE, and RMSSE validation',
      'Added safety stock, reorder point, EOQ, and Monte Carlo risk simulation',
      'Delivered API and dashboard interfaces'
    ],
    github: 'https://github.com/Animesh352/Supply-Chain-Demand-Forecasting',
    category: ['Forecasting', 'Data Engineering']
  },
  {
    id: 'infant-mri',
    title: 'Infant MRI ML Suite',
    description: 'Modular clinical AI project for infant brain MRI analysis, age prediction, benchmark evaluation, and biomarker reporting.',
    image: 'https://images.unsplash.com/photo-1758691463165-ca9b5bc2b28a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwYnJhaW4lMjBNUkl8ZW58MHx8fHwxNzc3Mzk2NTc0fDA&ixlib=rb-4.1.0&q=85',
    tags: ['Healthcare AI', 'Medical Imaging', 'Deep Learning'],
    tech: ['Python', 'PyTorch', 'TensorFlow', 'Streamlit', 'Medical Imaging', 'YAML'],
    highlights: [
      'Supports dataset validation, training, evaluation, and reporting workflows',
      'Includes configurable experiments for age prediction and model benchmarking',
      'Provides Streamlit UI for data, training, reports, benchmark results, and QA',
      'Designed for reproducible medical ML experimentation'
    ],
    github: 'https://github.com/Animesh352/Infant_mri',
    category: ['Healthcare AI']
  },
  {
    id: 'bookbot',
    title: 'BookBot',
    description: 'Book recommendation and conversational discovery project using NLP and semantic search concepts.',
    image: 'https://images.unsplash.com/photo-1568667256549-094345857637?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxib29rJTIwbGlicmFyeXxlbnwwfHx8fDE3NzczOTY1Nzh8MA&ixlib=rb-4.1.0&q=85',
    tags: ['NLP/LLM', 'Recommendation Systems'],
    tech: ['Python', 'NLP', 'Embeddings', 'Recommendation Systems'],
    highlights: [
      'Demonstrates applied NLP and recommendation workflow',
      'Useful for showing semantic search and user-facing AI interaction design'
    ],
    github: 'https://github.com/Animesh352/BookBot',
    category: ['NLP/LLM']
  },
  {
    id: 'document-classification',
    title: 'Intelligent Document Classification',
    description: 'Machine learning pipeline for automated document classification using text preprocessing and classification models.',
    image: 'https://images.unsplash.com/photo-1552833093-0522172fff1f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxkb2N1bWVudCUyMHByb2Nlc3Npbmd8ZW58MHx8fHwxNzc3Mzk2NTg0fDA&ixlib=rb-4.1.0&q=85',
    tags: ['NLP/LLM', 'Classification', 'Document AI'],
    tech: ['Python', 'Scikit-learn', 'NLP', 'Classification'],
    highlights: [
      'Demonstrates document intelligence, text processing, and model evaluation'
    ],
    github: 'https://github.com/Animesh352/Intelligent-Document-Classification',
    category: ['NLP/LLM', 'Data Engineering']
  },
  {
    id: 'streamdesk-ai',
    title: 'StreamDesk AI',
    description: 'Real-time incident triage platform that routes support tickets through Kafka, runs OpenAI-powered triage, and surfaces results in a live dashboard.',
    image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85',
    tags: ['NLP/LLM', 'ML Systems', 'Agents'],
    tech: ['Python', 'FastAPI', 'Kafka', 'Redpanda', 'OpenAI', 'Docker', 'SQLite'],
    highlights: [
      'Event-driven architecture: FastAPI producer publishes to Redpanda, worker consumes and triages',
      'OpenAI worker generates priority, routing, summary, recommended action, and customer response',
      'Fallback logic handles API failures without dropping tickets',
      'Full stack Docker Compose deployment -- one command to run locally',
      'Live dashboard with filter by priority and GenAI provider'
    ],
    github: 'https://github.com/Animesh352/streamdesk-ai',
    category: ['NLP/LLM', 'ML Systems']
  },
  {
    id: 'llm-agent-bench',
    title: 'LLM Agent Bench',
    description: 'Multi-agent LLM orchestration and benchmarking toolkit for evaluating whether planner-solver-reviewer workflows improve over single-model calls.',
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85',
    tags: ['NLP/LLM', 'ML Systems', 'Agents'],
    tech: ['Python', 'LangGraph', 'FastAPI', 'PostgreSQL', 'MLflow', 'OpenAI', 'Anthropic'],
    highlights: [
      'Planner-solver-reviewer workflow with explicit handoff tags and shared context blackboard',
      'Provider abstraction for local, OpenAI, and Anthropic models',
      'Benchmark runner over JSONL task sets with exact, numeric, and keyword scoring',
      'FastAPI endpoint, Postgres persistence, and MLflow experiment tracking',
      'Local demo runs without API keys'
    ],
    github: 'https://github.com/Animesh352/llm-agent-bench',
    category: ['NLP/LLM']
  },
  {
    id: 'stroke-prediction',
    title: 'Stroke Risk Prediction',
    description: 'Clinical ML pipeline comparing four classifiers on structured EHR-style features for stroke risk prediction, with class imbalance handled via SMOTE.',
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85',
    tags: ['Healthcare AI', 'Clinical ML'],
    tech: ['Python', 'Scikit-learn', 'XGBoost', 'Keras', 'SMOTE'],
    highlights: [
      'Compared Logistic Regression, XGBoost, Naive Bayes, and Neural Network on 5,110 patient records',
      'Applied SMOTE to training split only to prevent data leakage into test set',
      'Best model: Logistic Regression + SMOTE, ROC-AUC 0.706',
      'Showed accuracy is misleading on 4.2% positive-rate data -- all no-SMOTE models collapse to majority class'
    ],
    github: 'https://github.com/Animesh352/StrokePredictionML',
    category: ['Healthcare AI']
  },
  {
    id: 'lung-subtype-explorer',
    title: 'Lung Cancer Subtype Explorer',
    description: 'FastAPI service over TCGA RNA-seq data for LUAD/LUSC lung cancer subtype classification, differential expression analysis, and SHAP-ranked gene browser.',
    image: 'https://images.unsplash.com/photo-1530210124550-912dc1381cb8?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85',
    tags: ['Healthcare AI', 'Genomics', 'Bioinformatics'],
    tech: ['Python', 'FastAPI', 'XGBoost', 'R', 'limma', 'SHAP', 'PostgreSQL'],
    highlights: [
      'XGBoost and logistic regression classifiers trained on limma differential expression genes',
      'Limma-based differential expression pipeline in R for LUAD vs LUSC contrast',
      'SHAP-ranked gene importance browser for model interpretability',
      'REST API with PostgreSQL backend over TCGA LUAD/LUSC cohort'
    ],
    github: 'https://github.com/Animesh352/lung-subtype-explorer',
    category: ['Healthcare AI']
  }
];

export const filters = ['All', 'Healthcare AI', 'NLP/LLM', 'Forecasting', 'Data Engineering'];
